import { environment } from '../environments/environment';
declare var CryptoJS: any;
declare var ezcrypto: any;
declare var $: any;
declare let ga: Function;

export class AppConfig {
    public PROD: boolean = environment.production;
    public DEBUG: boolean = environment.dev;
    private TEST: boolean = environment.test;
    private API_PORT = '';
    private API_AUX_PORT = ':8085';
    private BASE_API_URL_PROD = 'https://intranet.uoh.cl';
    private BASE_API_URL_DEV = 'https://dev.uoh.cl';
    private BASE_API_URL_TEST = 'https://test.uoh.cl';
    public BASE_URL = this.DEBUG ? this.BASE_API_URL_DEV : (this.TEST ? this.BASE_API_URL_TEST : this.BASE_API_URL_PROD);
    public BASE_API_URL = (this.BASE_URL) + this.API_PORT + '/api/v1';
    public BASE_API_AUX_URL = (this.BASE_URL) + this.API_AUX_PORT + '/api/v1';
    public API_TOKEN = 'qm0EbxtkxWPabmINGFhX';
    public MAX_HOURS = 9;
    public START_DAY = 9;
    public END_DAY = 18;
    private months: any = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    public NO_TYPES_PUBLIC_SITE: any = ['WORKSHOP', 'SEMINARIO', 'PME_REGIONAL', 'LATINMAG', 'ENCUENTRO_MATEMATICA', 'FIC', 'DIPLOMADO_RIEGO_NUTRICION', 'FPA'];
    public current_year: string = new Date().getFullYear().toString();
    public static readonly ID_SESSION_TOKEN: string = 'plain-signing-token';
    public static readonly CLERK_DATA: string = 'user-data';
    public readonly SUFFIX_APP: string = '/firma-simple/';
    public readonly HOME = (this.DEBUG ? this.BASE_API_URL_DEV : (this.TEST ? this.BASE_API_URL_TEST : this.BASE_API_URL_PROD)) + (this.PROD ? '/' : this.SUFFIX_APP);
    public readonly LOGOUT_CLAVE_UNICA: string = 'https://accounts.claveunica.gob.cl/api/v1/accounts/app/logout?redirect='+encodeURIComponent(this.HOME);


/*     public setGA() {
        var link = "";
        if (this.PROD) {
            // link = this.BASE_URL.substr(7, 4);
            // console.log(location.pathname + location.search + location.hash);
            ga('send', 'pageview', {
                'page': location.pathname + location.search + location.hash
            });
        }

    } */

    public strReplace(myStr: string) {
        let cResul = this.cleanStrings(myStr);
        let newStr: string = cResul.replace(/"/g, "'");

        // Insert modified string in paragraph
        return newStr;
    }




    public slug(str: string) {
        str = str.replace(/^\s+|\s+$/g, ''); // trim
        str = str.toLowerCase();

        // remove accents, swap ñ for n, etc
        let from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
        let to = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";
        for (let i = 0, l = from.length; i < l; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }

        str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
            .replace(/\s+/g, '-') // collapse whitespace and replace by -
            .replace(/-+/g, '-'); // collapse dashes

        return str;
    }

    public cleanStrings(str: string) {
        str = str.replace(/^\s+|\s+$/g, ''); // trim

        let from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
        let to = "ÁAAAAACCCDÉEEEEEEEIIIINNÓOOOOORRSTÚUUUUYYZáaaaaacccdéeeeeeeeíiiinñóoooooorrstúuuuuyyzbBDdBAa------";
        for (let i = 0, l = from.length; i < l; i++) {
            str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }

        str = str.replace(/[^@ . $ A-Za-z0-9ÁÉÍÓÚáéíóúñÑ -]/g, '') // remove invalid chars
            .replace(/\s+/g, ' '); // collapse whitespace and replace by -

        return str;
    }

    public formatMoney(number: any, places?: any, symbol?: string, thousand?: string, decimal?: string): string {
        places = !isNaN(places = Math.abs(places)) ? places : 0;
        symbol = symbol !== undefined ? symbol : '$';
        thousand = thousand || '.';
        decimal = decimal || ',';

        let negative = number < 0 ? '-' : '';
        let i: any = parseInt(number = Math.abs(+number || 0).toFixed(places), 10) + '';
        let j: any = i.length;
        j = j > 3 ? j % 3 : 0;

        return symbol + ' ' + negative + (j ? i.substr(0, j) + thousand : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand) + (places ? decimal + Math.abs(number - i).toFixed(places).slice(2) : '');
    }

    public stripos(h: string, n: string, o?: number): any {
        let haystack = (h + '').toLowerCase();
        let needle = (n + '').toLowerCase();
        let index = 0;

        if ((index = haystack.indexOf(needle, o)) !== -1)
            return index;

        return false;
    }


    public isEmail(email: string): boolean {
        let regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        return regex.test(email);
    }

    public invertDate(date: string): string {
        if (date == "" || date == null)
            return date;

        return date.split('T')[0].split('-').reverse().join('-');
    }


    public encrypt(data: string, key?: string): string {
        key = key || this.API_TOKEN;
        return btoa(encodeURIComponent(data + key).replace(/%([0-9A-F]{2})/g, function (match, p1) {
            return String.fromCharCode(parseInt(p1, 16))
        }))
    }

    public decrypt(data: string, key?: string): string {
        key = key || this.API_TOKEN;
        let r: string = decodeURIComponent(Array.prototype.map.call(atob(data), function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        }).join(''));
        let pos: number = r.lastIndexOf(key);
        return r.substring(0, pos);
    }

    public decryptLogin(data: string, key?: string): string {
        key = key || this.API_TOKEN;
        let r: string = decodeURIComponent(Array.prototype.map.call(atob(data), function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        }).join(''));
        let pos: number = r.lastIndexOf(key);
        return r.substring(0, pos);
    }

    public isValidExternalRequest(data: string, key?: string): boolean {
        key = key || this.API_TOKEN;
        return atob(data).indexOf(key) != -1;
    }

    public isInt(s: string): boolean {
        if (s.split(' ').length > 1) return false;
        return parseInt(s).toString() != 'NaN';
    }

    public intToBoolean(i: number): boolean {
        return i == 1;
    }

    public isArray(a: string): boolean {
        try {
            return Array.isArray(JSON.parse(a));
        } catch (e) {
            return false;
        }
    }

    public ezencrypt(value: string): string {
        return ezcrypto.encrypt(value, { private: this.API_TOKEN, public: this.API_TOKEN });
    }

    public ezdecrypt(value: string): string {
        return ezcrypto.decrypt(value, { private: this.API_TOKEN, public: this.API_TOKEN });
    }

    public humanDate(d?: any): string {
        if (typeof d == 'string') {
            try {
                d = new Date(d);
            } catch (e) {
                d = new Date();
            }
        }
        d = d || new Date();
        d = new Date(d.getTime() + d.getTimezoneOffset() * 60000);
        return d.getDate() + ' de ' + this.months[d.getMonth()] + ' de ' + d.getFullYear();
    }

    public humanDateFromString(d?: any): string {
        d = d.split('-');
        return d[2] + ' de ' + this.months[d[1]] + ' de ' + d[0];
    }

    public chatDate(d?: any): string {
        if (typeof d == 'string') {
            try {
                d = d.split('.')[0];
                d = new Date(d);
            } catch (e) {
                d = new Date();
            }
        }
        d = d || new Date();
        let hours: any = d.getHours();
        let ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours > 9 ? hours : '0' + hours;
        let minutes: any = d.getMinutes();
        minutes = minutes > 9 ? minutes : '0' + minutes;
        return d.getDate() + ' ' + this.months[d.getMonth()].substring(0, 3) + ' ' + d.getFullYear() + ' ' + hours + ':' + minutes + ' ' + ampm;

    }

    public getTime(d?: any, add_ampm?: boolean): string {
        add_ampm = add_ampm || false;
        if (typeof d == 'string') {
            try {
                d = d.split('.')[0];
                d = new Date(d);
            } catch (e) {
                d = new Date();
            }
        }
        d = d || new Date();
        let hours: any = d.getHours();
        const ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours > 9 ? hours : '0' + hours;
        let minutes: any = d.getMinutes();
        minutes = minutes > 9 ? minutes : '0' + minutes;
        return hours + ':' + minutes + (add_ampm ? ' ' + ampm : '');
    }

    public getTimeWithSeconds(d?: any, add_ampm?: boolean): string {
        add_ampm = add_ampm || false;
        if (typeof d == 'string') {
            try {
                d = d.split('.')[0];
                d = new Date(d);
            } catch (e) {
                d = new Date();
            }
        }
        d = d || new Date();
        let hours: any = d.getHours();
        const ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours > 9 ? hours : '0' + hours;
        let minutes: any = d.getMinutes();
        minutes = minutes > 9 ? minutes : '0' + minutes;
        let seconds: any = d.getSeconds();
        seconds = seconds > 9 ? seconds : '0' + seconds;
        return hours + ':' + minutes + ':' + seconds + (add_ampm ? ' ' + ampm : '');
    }

    public addDays(date: any, days: number, asString: boolean = false): any {
        if (typeof date == 'string') {
            try {
                date = date.split('.')[0];
                date = new Date(date);
            } catch (e) {
                date = new Date();
            }
        }
        let result = date || new Date();
        if (days < 1) {
            result = this.addHours(date, days);
        } else {
            let tmp: any = days.toString().split('.');
            let d: number = parseInt(tmp[0]);
            let h: number = days % d;
            while (d--) {
                result.setDate(date.getDate() + ((date.getDay() == 5) ? 3 : 1));
            }
            if (h > 0)
                result = this.addHours(result, h);
        }
        return asString ? this.chatDate(result) : result;
    }

    public addHours(date: any, days: number, asString: boolean = false): any {
        if (typeof date == 'string') {
            try {
                date = date.split('.')[0];
                date = new Date(date);
            } catch (e) {
                date = new Date();
            }
        }
        let result = date || new Date();
        days = days * this.MAX_HOURS;
        let h_tmp: number = date.getHours() + days;
        if (h_tmp > 18) {
            h_tmp -= this.END_DAY;
            result.setDate(date.getDate() + ((date.getDay() == 5) ? 3 : 1));
            result.setHours(this.START_DAY + h_tmp);
        } else
            result.setHours(date.getHours() + days);
        return asString ? this.chatDate(result) : result;
    }

    public get_full_date(invert?: boolean): string {
        let full_date: string;
        let day: string = new Date().getDate().toString();
        let month: string = (new Date().getMonth() + 1).toString();
        let year: string = new Date().getFullYear().toString();

        if (invert)
            full_date = year + '-' + (parseInt(month) < 10 ? '0' + month : month) + '-' + (parseInt(day) < 10 ? '0' + day : day);
        else
            full_date = (parseInt(day) < 10 ? '0' + day : day) + '-' + (parseInt(month) < 10 ? '0' + month : month) + '-' + year;

        return full_date;
    }


    public getMonth(month: number): string {
        if (month == -1) {
            return 'Deuda';
        }
        return this.months[month];
    }


    public upperCase(s: string): string {
        return s.toUpperCase();
    }

    public _parseInt(n: any): any {
        try {
            return parseInt(n);
        } catch (e) {
            return '';
        }
    }

    public isHtml(text: string): boolean {
        return /<(br|basefont|hr|input|source|frame|param|area|meta|!--|col|link|option|base|img|wbr|!DOCTYPE).*?>|<(a|abbr|acronym|address|applet|article|aside|audio|b|bdi|bdo|big|blockquote|body|button|canvas|caption|center|cite|code|colgroup|command|datalist|dd|del|details|dfn|dialog|dir|div|dl|dt|em|embed|fieldset|figcaption|figure|font|footer|form|frameset|head|header|hgroup|h1|h2|h3|h4|h5|h6|html|i|iframe|ins|kbd|keygen|label|legend|li|map|mark|menu|meter|nav|noframes|noscript|object|ol|optgroup|output|p|pre|progress|q|rp|rt|ruby|s|samp|script|section|select|small|span|strike|strong|style|sub|summary|sup|table|tbody|td|textarea|tfoot|th|thead|time|title|tr|track|tt|u|ul|let|video).*?<\/\2>/i.test(text);
    }

    public diffBetweenDates(date1: any, date2: any): number {
        if (typeof date1 == 'string') {
            try {
                date1 = date1.split('.')[0];
                date1 = new Date(date1);
            } catch (e) {
                date1 = null;
            }
        }
        if (typeof date2 == 'string') {
            try {
                date2 = date2.split('.')[0];
                date2 = new Date(date2);
            } catch (e) {
                date2 = null;
            }
        }
        if (date1 !== null && date2 != null) {
            const diff_time = Math.abs(date2 - date1);
            const diff_days = Math.ceil(diff_time / (1000 * 60 * 60 * 24));
            return diff_days;
        } else return 0;
    }

    public localCapitalize(sentence: string, first_word?: boolean) {
        first_word = first_word || false;
        let newSentence: Array<string> = sentence.split('');
        newSentence.forEach((char, i, array) => {
            i == 0 ? array[i] = char.toUpperCase() : (first_word && array[i - 1] == ' ' ? array[i] = char.toUpperCase() : array[i] = char.toLowerCase());
        });
        return newSentence.join('');
    }

    public formatDate(date: any) {

        let dateArray = date.split('-');
        let year = dateArray[0];
        let month = dateArray[1];
        let day = dateArray[2];

        return [day, month, year].join('-');
    }

    public formatNumber(n) {
        // format number 1000000 to 1,234,567
        return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }

    public formatCurrency(input: any, blur: any) {
        // appends $ to value, validates decimal side
        // and puts cursor back in right position.

        // get input value
        let input_val: any = input.val();

        // don't validate empty input
        if (input_val === "") { return; }

        // original length
        let original_len: any = input_val.length;

        // initial caret position
        let caret_pos: any = input.prop("selectionStart");

        // check for decimal
        if (input_val.indexOf(",") >= 0) {

            // get position of first decimal
            // this prevents multiple decimals from
            // being entered
            let decimal_pos: any = input_val.indexOf(",");

            // split number by decimal point
            let left_side: any = input_val.substring(0, decimal_pos);
            let right_side: any = input_val.substring(decimal_pos);

            // add commas to left side of number
            left_side = this.formatNumber(left_side);

            // validate right side
            right_side = this.formatNumber(right_side);

            // On blur make sure 2 numbers after decimal
            if (blur === "blur") {
                right_side += "00";
            }

            // Limit decimal to only 2 digits
            right_side = right_side.substring(0, 2);

            // join number by .
            input_val = "$" + left_side + "," + right_side;

        } else {
            // no decimal entered
            // add commas to number
            // remove all non-digits
            input_val = this.formatNumber(input_val);
            input_val = "$" + input_val;

            // final formatting
        }

        // send updated string to input
        input.val(input_val);

        // put caret back in the right position
        let updated_len: any = input_val.length;
        caret_pos = updated_len - original_len + caret_pos;
        input[0].setSelectionRange(caret_pos, caret_pos);
    }

    public reverseFormatDate(date: any) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        return [year, day, month].join('-');
    }



    public capitalize(s) {
        if (typeof s !== 'string') return ''
        return s.charAt(0).toUpperCase() + s.slice(1)
    }

    // Entrega la fecha del día actual con 30 min más agregados.
    public IsoDate30min(){
        let oficialDate:any;
        let minutesToAdd=30;
        let currentDate = new Date();
        let futureDate = new Date(currentDate.getTime() + minutesToAdd*60000);
        let dateArray: any = futureDate.toISOString().split('T')
        let timeChile = dateArray[1].replace(dateArray[1].slice(0,2), String(futureDate.getHours()))
        dateArray[1] = timeChile;
        dateArray = dateArray.join('T')
        dateArray = dateArray.split('.')
        oficialDate = dateArray.shift()

        return oficialDate;
    }
}
